export default __webpack_public_path__ + "static/Zenaide Parteira_MiniBio2-78ee75754ddc027acb9f58bef37adee9.webp";